// Port of api/fuel/app/classes/insights/players/activity.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

function monthIndex(ts) {
	var y = parseInt(Util.date('Y', ts), 10)
	var m = parseInt(Util.date('c', ts), 10)
	return ((y - 1970) * 12) + (m - 1)
}

function monthIndexToTs(index) {
	var year = 1970 + Math.floor(index / 12)
	var month = (index % 12) + 1
	return Util.mktime(0, 0, 0, [1, month, year])
}

export default Segment.extend({
	name: 'activity',
	requires: ['init'],
	types: [Constants.TYPE_USER],
	detail: ['activity'],
	run: function(type, owner, userIndex, detail, filter, vars) {
		var activity = {}
		var players = this._data.players || []
		var band = (vars && vars.band !== undefined) ? parseInt(vars.band, 10) : 0
		var range = this.get_period_date_range(type, owner, filter || {})
		var startMonth = monthIndex(range.start)
		var endMonth = monthIndex(range.end)
		var period = (filter && filter.period) ? filter.period : 'all'

		if (period !== 'all' && !detail) {
			for (var i = startMonth; i <= endMonth; i++) {
				activity[i] = {
					period: i,
					label: Util.date('m.y', monthIndexToTs(i)),
					new: 0,
					returning: 0
				}
			}
		}

		for (var p = 0; p < players.length; p++) {
			var player = players[p]
			var first = !(player.dateFirst < range.start)

			if (period === 'all') {
				for (var y = 0; y < player.years.length; y++) {
					var year = player.years[y]
					if (detail) {
						if (!activity[year]) activity[year] = { new: [], returning: [] }
						player.activityType = first ? 'new' : 'returning'
						activity[year][player.activityType].push(player)
					} else {
						if (!activity[year]) activity[year] = { period: year, label: year, new: 0, returning: 0 }
						activity[year][first ? 'new' : 'returning']++
					}
					first = false
				}
			} else {
				for (var m = 0; m < player.months.length; m++) {
					var month = player.months[m]
					if (month >= startMonth && month <= endMonth) {
						if (detail) {
							if (!activity[month]) activity[month] = { new: [], returning: [] }
							player.activityType = first ? 'new' : 'returning'
							activity[month][player.activityType].push(player)
						} else {
							if (!activity[month]) activity[month] = { period: month, new: 0, returning: 0 }
							activity[month][first ? 'new' : 'returning']++
						}
					}
					first = false
				}
			}
		}

		if (detail) {
			var keys = Object.keys(activity).map(function(key) { return parseInt(key, 10) }).sort(function(a, b) { return a - b })
			if (!keys.length || keys[band] === undefined) return { activity: [] }

			var bucket = activity[keys[band]]
			var list = bucket.new.concat(bucket.returning).map(function(player) {
				return {
					id: parseInt(player.id, 10) || 0,
					slug: player.slug,
					name: player.primaryName,
					username: player.username,
					type: player.activityType,
					count: parseInt((player.playYears || {})[keys[band]], 10) || 0
				}
			})

			list = Util.sort_by_field(list, 'name', 'asc')

			return {
				activity: list
			}
		}

		var activityList = Util.sort_by_field(Object.keys(activity).map(function(key) {
			return activity[key]
		}), 'period', 'asc')
		if (activityList.length > 20) activityList = activityList.slice(-20)

		return {
			activity: activityList
		}
	}
})
